import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import Project from 'models/project/project.model';
import User from 'models/user/user.model';
import { CreateProjectComponent } from 'modules/project/create-project/create-project.component';
import { ProjectService } from 'services/project/project.service';
import { OrganizationUnitService } from 'services/organization-unit/organization-unit.service';
import { UserService } from 'services/user/user.service';

@Component({
  selector: 'app-organization-unit-project-list',
  templateUrl: './organization-unit-project-list.component.html',
  styleUrls: ['./organization-unit-project-list.component.scss'],
})
export class OrganizationUnitProjectListComponent implements OnInit, OnDestroy {
  @Input() organizationUnit: OrganizationUnit = new OrganizationUnit();
  public user: User = new User();
  public projectList: Project[] = [];

  private currentUserSubscription: Subscription;

  constructor(
    private dialog: MatDialog,
    public projectService: ProjectService,
    public userService: UserService,
    public organizationUnitService: OrganizationUnitService,
  ) { }

  async ngOnInit() {
    this.projectList = await this.projectService.findByOu(this.organizationUnit);
    this.currentUserSubscription = this.userService.getCurrentUser().subscribe((u) => this.user = u);
  }

  async createProject() {
    const saveSubject: Subject<string> = new Subject();
    this.dialog.open(CreateProjectComponent, {
      data: {
        organizationUnit: this.organizationUnit,
        subj: saveSubject,
      },
    });
    saveSubject.subscribe(async () => {
      this.projectList = await this.projectService.findByOu(this.organizationUnit);
    });
  }

  ngOnDestroy() {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }
}
